import { DEFAULT_FILTER, DISTANCE_FILTER, YEARS_CERTIFIED_FILTER } from '../constants.js';

const SearchFilter = (props) => {
    const handleClick = (event) => {
        let target = event.target
        let value = target.innerHTML

        if (value === 'Years as an ACE Pro') value = YEARS_CERTIFIED_FILTER

        props.setSortByFunction(value)

    }

    return (
        <div className="ace-pro-location-search__filters">
            <span>
                Sort by:&nbsp;
                <a className={props.sortBy === DEFAULT_FILTER ? "active" : null} onClick={handleClick}>Default</a>
                &nbsp;|&nbsp;
                <a className={props.sortBy === DISTANCE_FILTER ? "active" : null} onClick={handleClick}>Distance</a>
                &nbsp;|&nbsp;
                <a className={props.sortBy === YEARS_CERTIFIED_FILTER ? "active" : null} onClick={handleClick}>Years as an ACE Pro</a>
            </span>
        </div>
    )
}

export default SearchFilter